
(function () {
  const product = window.POSHEY_PRODUCT;
  if (!product || !product.variants) return;

  const root = document.getElementById("replo-fullpage-element");
  if (!root) return;

  // Helpers
  const $ = (sel, ctx = root) => ctx.querySelector(sel);
  const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

  // Option selects (expect 3: color, size, quantity)
  const optionSelects = $$('[data-replo-option-select="true"][role="listbox"]');

  // Replo uses selected state via aria-selected + tabindex
  function setSelected(listbox, index) {
    const options = $$('[role="option"]', listbox);
    options.forEach((opt, i) => {
      const selected = i === index;
      opt.setAttribute("aria-selected", selected ? "true" : "false");
      opt.tabIndex = selected ? 0 : -1;
    });
  }

  function getSelectedIndex(listbox) {
    const options = $$('[role="option"]', listbox);
    const idx = options.findIndex(o => o.getAttribute("aria-selected") === "true");
    return idx >= 0 ? idx : 0;
  }

  // Build option value maps based on product option ordering
  // Shopify options: product.options[0..2] and variants[].options[0..2]
  const optionValues = product.options.map((_, optIndex) => {
    const set = new Set();
    product.variants.forEach(v => set.add(v.options[optIndex]));
    return Array.from(set);
  });

  // Price nodes in Replo markup
  const priceNodes = $$('[data-replo-price="true"]');

  // Form / ATC
  const form = $('form[action="/cart/add"]');
  const idInput = form ? form.querySelector('input[name="id"]') : null;
  const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;

  function money(cents) {
    // Replo displays like $90.00
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  function findVariant(color, size, qtyLabel) {
    return product.variants.find(v => {
      return v.options[0] === color && v.options[1] === size && v.options[2] === qtyLabel;
    });
  }

  function sync() {
    // Determine selected option indices (fallback 0)
    const cIdx = optionSelects[0] ? getSelectedIndex(optionSelects[0]) : 0;
    const sIdx = optionSelects[1] ? getSelectedIndex(optionSelects[1]) : 0;
    const qIdx = optionSelects[2] ? getSelectedIndex(optionSelects[2]) : 0;

    const color = optionValues[0]?.[cIdx] ?? product.variants[0].options[0];
    const size  = optionValues[1]?.[sIdx] ?? product.variants[0].options[1];
    const qtyLabel = optionValues[2]?.[qIdx] ?? product.variants[0].options[2];

    const variant = findVariant(color, size, qtyLabel) || product.variants[0];

    // Update hidden variant id + quantity (keep qty as 1; bundle quantity is handled by variant pricing)
    if (idInput) idInput.value = String(variant.id);
    if (qtyInput) qtyInput.value = "1";

    // Update any price display elements
    priceNodes.forEach(node => {
      node.textContent = money(variant.price);
    });

    // Update URL with variant parameter (deep links)
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", String(variant.id));
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  // Bind click handlers to each option listbox
  optionSelects.forEach((listbox, listIndex) => {
    const options = $$('[role="option"]', listbox);
    options.forEach((opt, i) => {
      opt.addEventListener("click", () => {
        setSelected(listbox, i);
        sync();
      });
      opt.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setSelected(listbox, i);
          sync();
        }
      });
    });
  });

  // Collapsibles (FAQ)
  $$('[data-replo-collapsible="true"]').forEach(wrapper => {
    const button = wrapper.querySelector('[role="button"][aria-controls]');
    if (!button) return;
    const panelId = button.getAttribute("aria-controls");
    const panel = document.getElementById(panelId);
    if (!panel) return;

    button.addEventListener("click", () => {
      const isOpen = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", isOpen ? "false" : "true");
      if (isOpen) panel.setAttribute("hidden", "");
      else panel.removeAttribute("hidden");
    });
  });

  // Add to Cart button – if Replo markup has a visible button outside the hidden product-form,
  // Shopify will still submit the form if it's inside the form. If not, we bind a click to submit.
  const atc = $$('button, a').find(el => (el.textContent || "").trim().toLowerCase() === "add to cart");
  if (atc && form) {
    atc.addEventListener("click", (e) => {
      // If it's already a submit button inside the form, let it submit naturally.
      if (atc.tagName === "BUTTON" && atc.type === "submit") return;
      e.preventDefault();
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  // Initial state:
  // If URL has ?variant=, set selects accordingly
  const url = new URL(window.location.href);
  const vParam = url.searchParams.get("variant");
  if (vParam) {
    const v = product.variants.find(x => String(x.id) === String(vParam));
    if (v) {
      // Map variant options to indices and set selected
      const ci = optionValues[0]?.indexOf(v.options[0]) ?? 0;
      const si = optionValues[1]?.indexOf(v.options[1]) ?? 0;
      const qi = optionValues[2]?.indexOf(v.options[2]) ?? 0;
      if (optionSelects[0]) setSelected(optionSelects[0], Math.max(ci,0));
      if (optionSelects[1]) setSelected(optionSelects[1], Math.max(si,0));
      if (optionSelects[2]) setSelected(optionSelects[2], Math.max(qi,0));
    }
  }

  sync();
})();
